/* angular:styles/component:css;b5227b854a0cbc1025e3eb5c53140795f7f446abde8d5836bb2b6cffecde5572;/app/src/app/shared/animations/circle-loader.component.ts */
.circle {
  border-style: solid;
  border-color: transparent;
  border-top: solid #dfdfdf;
  border-right: solid #dfdfdf;
  border-bottom: solid #dfdfdf;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=circle-loader.component.css.map */
